import React from 'react'

const zahtjevOutput = (props) => {
    return (
        <>
            <h5>Hvala što ste koristili Online servis za predaju dokumentacije.</h5>
            <br />
            <h5>Status rješavanja Vašeg zahtjeva bit će moguće pratiti putem Online servisa za predaju dokumentacije.</h5>
            <h5>Vaš zahtjev je zaprimljen <u><b>{props.tstampZaprimanja}</b></u> pod brojem <u><b>{props.idZahtjeva}</b></u>.</h5>
            <h5>Kako biste uspješno pratili status rješavanja Vašeg zahtjeva potrebno je broj zahtjeva ({props.idZahtjeva}) zapisati ili zapamtiti.</h5>

            <br />
            <span className="d-flex justify-content-end"><h6>Vaša Fina</h6></span>
        </>
    )
}

export default zahtjevOutput
